import { CUSTOM_UNITS, CustomTrace, RechartData, RechartDataObject } from 'src/Libs/chart-kit'
import { useMemo } from 'react'
import { traceConf } from 'src/Libs/system-charts/shared'
import { formatNumberWithSIPrefix, STATISTICS_SI_PREFIXES } from 'src/Libs/system-data-handler/utils/formatNumberWithSIPrefix'

/**
 * Determine the highest SI prefix tier needed so that all left-axis ticks have the same unit (e.g. all kW instead of mixing W and kW).
 */
export const useMinPrefix = (rechartData: RechartData | undefined, customTraces: CustomTrace[] | undefined, minPrefix = 0): number => {
  const getHighestUsedPrefix = (data: RechartDataObject[], leftAxisKeys: string[], initialPrefix: number): number => {
    let highestUsedPrefix = initialPrefix

    for (const row of data) {
      for (const key of leftAxisKeys) {
        const val = row[key]
        if (typeof val === 'number') {
          const [, , prefixNumber] = formatNumberWithSIPrefix(val, 0, undefined, STATISTICS_SI_PREFIXES)
          if (prefixNumber > highestUsedPrefix) {
            highestUsedPrefix = prefixNumber
          }
        }
      }
    }
    return Math.max(highestUsedPrefix, minPrefix)
  }

  return useMemo(() => {
    if (!rechartData || !customTraces) return minPrefix

    const data = rechartData.data
    if (!data?.length || !customTraces) return minPrefix

    const leftAxisKeys = customTraces
      .filter(ct => traceConf[ct.key] && !CUSTOM_UNITS.includes(traceConf[ct.key].unit ?? ''))
      .map(ct => ct.alternateKey ?? ct.key)

    return getHighestUsedPrefix(data, leftAxisKeys, minPrefix)
  }, [rechartData?.data, customTraces, minPrefix]) // eslint-disable-line react-hooks/exhaustive-deps
}
